var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"action-float-left mx-1"},[_c('vx-tooltip',{attrs:{"text":_vm.tooltip}},[_c('feather-icon',{attrs:{"icon":_vm.icon,"svgClasses":"h-5 w-5 hover:text-primary cursor-pointer action-block"},on:{"click":this.export}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }